// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"451161be","453":"f38ac45c","732":"14235488","952":"4e171197","977":"78a157de"}[chunkId] + ".chunk.js";
};